import script from "./editeStockAllocationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./editeStockAllocationForm.vue?vue&type=script&setup=true&lang=js"

import "./editeStockAllocationForm.vue?vue&type=style&index=0&id=0d6753f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6753f2"]])

export default __exports__